/* eslint-disable no-unsafe-optional-chaining */

/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';

import Image from 'next/image';

import cardsimage from '../../assets/images/fixed-mock/cardsimages.png';

import { formatDate } from '../../utils/helper';

import styles from '../../styles/timebase-testseries.module.scss';
import ActionButton from './ActionButton';
import TimeStatus from './TimeStatus';

function TestseriseMobile({
  getalltest,
  handleRegister,
  blinkicon,
  handleViewAll,
  handlepagination,
  isAuthenticated,
  handleShowLogin,
  totalpage,
  pagenumber,
  getDataFlag,
}) {
  return (
    <div className={styles.TestseriseMobileWrapper}>
      {isAuthenticated ? (
        <>
          {getalltest.length > 0 && (
            <div className={styles.viewAllwrapper}>
              <div className={styles.testheadiing}>Free Time Based Tests</div>
              <div>
                <button className={styles.viewall} onClick={handleViewAll} type="button">
                  View All
                </button>
              </div>
            </div>
          )}
          <div className={styles.TestseriseMobile}>
            {getalltest.map((item) => (
              <div className={`${styles.cardwarpper}`} key={item?.id}>
                <div className={`${styles.cardwarpper}`}>
                  <div className={`${styles.card}`}>
                    <div>
                      <div className={styles.title_wrapper}>
                        <span className={styles.title_Freetab}>
                          <b>Free</b>
                        </span>
                        <span className={styles.title}>
                          <b>{item?.examId}</b>
                        </span>
                      </div>
                      <div className={`${styles.contetentwrapper}`}>
                        <span className={styles.subheading}>{item?.title}</span>
                      </div>
                      <div className={styles.actionwrapper}>
                        <ShowResult item={item} />
                        <ActionButton item={item} handleRegister={handleRegister} />
                      </div>
                    </div>
                  </div>
                  <div className={styles.cardfooter}>
                    <TimeStatus item={item} getDataFlag={(data) => getDataFlag(data)} />
                    <span>
                      <div className={styles.statuslive}>
                        {item?.live && (
                          <>
                            {blinkicon ? (
                              <Image alt="liveicon" src="/liveicondark.png" height={10} width={15} />
                            ) : (
                              <Image alt="liveicon" src="/liveiconlight.png" height={10} width={15} />
                            )}
                            <span className={styles.livetext}>Live</span>
                          </>
                        )}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {getalltest?.length > 0 && pagenumber < totalpage && (
              <div className={styles.viewMoreWrapperMobile}>
                <button type="button" className={styles?.viewmoremobile} onClick={handlepagination}>
                  View More
                </button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className={`${styles.mobilelogincontentwrapper}`}>
          {[1, 2]?.map(() => (
            // eslint-disable-next-line react/jsx-key
            <Image height={120} width={120} alt="cards" src={cardsimage} />
          ))}
          <div className={styles.textLoging}>
            <div className={styles.subTextforLogin}>Login to view all our scholarship tests</div>
            <div className={styles.buttonwrapper}>
              <button onClick={handleShowLogin} className={styles.login_button} type="button">
                Login
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default TestseriseMobile;
function ShowResult({ item }) {
  const date = new Date();
  const resultTime = item?.resultTime;
  const currenttime = Date.parse(date);
  return (
    <span className={styles?.conut}>
      {currenttime < resultTime && item?.userTestStatus === 'COMPLETED' ? (
        <>
          {'Result out on '}
          {formatDate(item?.resultTime, 'dd MMM, hh:mm aaa')}
        </>
      ) : (
        <>
          {`${item?.questionCount} Qs • ${item?.duration / 60} Mins
    • ${item?.maxMarks} Marks`}
        </>
      )}
    </span>
  );
}
